

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import MyAlpacas from '@/components/MyAlpacas.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { Alpaca } from '@/backend/type';
import {
  squadBatchTransfer,
  squadRetieve,
  maxAlpacaSquadCount,
} from '@/utils/web3';

@Component({
  components: {
    MyAlpacas,
    AlpacaBtn,
  },
})
export default class SelectSquadPopup extends Vue {
  @Prop({
    type: Boolean,
    required: true,
    default: false,
  })
  public value!: boolean;

  @Prop({
    type: String,
    required: true,
  })
  public tab!: 'assign' | 'recall';

  @Prop({
    type: Number,
    required: true,
  })
  public squadCount!: number;

  public curTab: 'assign' | 'recall' = 'assign';
  public assigningAlpacas: string[] = [];
  public recallingAlpacas: string[] = [];
  public maxSquadCount: number = 20;
  public maxWarningShow: boolean = false;

  get account() {
    return this.$store.getters.getAccount;
  }

  public mounted() {
    this.curTab = this.tab;
    this.getMaxAlpacaSquadCount();
  }

  public changeState(state: boolean) {
    this.$emit('input', state);
  }

  public close() {
    this.changeState(false);
  }

  public changeTab(tab: 'assign' | 'recall') {
    this.curTab = tab;
  }

  public async getMaxAlpacaSquadCount() {
    const amount = await maxAlpacaSquadCount();
    if (amount) {
      this.maxSquadCount = amount;
    }
  }

  public toggleAlpaca(id: string) {
    if (this.curTab === 'assign') {
      const index = this.assigningAlpacas.indexOf(id);
      if (index !== -1) {
        this.assigningAlpacas.splice(index, 1);
      } else if (this.assigningAlpacas.length + this.squadCount < this.maxSquadCount) {
        this.assigningAlpacas.push(id);
      } else {
        this.maxWarningShow = true;
      }
    } else {
      const index = this.recallingAlpacas.indexOf(id);
      if (index !== -1) {
        this.recallingAlpacas.splice(index, 1);
      } else {
        this.recallingAlpacas.push(id);
      }
    }
  }

  public clickAlpacaCard(alpaca: Alpaca) {
    this.toggleAlpaca(alpaca.id);
  }

  public handleAssign() {
    squadBatchTransfer(this.account, this.assigningAlpacas);
    this.close();
  }

  public handleRecall() {
    squadRetieve(this.account, this.recallingAlpacas);
    this.close();
  }
}
